/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlytzcollectAnalyticsRouteImport } from './routes/blytzcollect/analytics'
import { Route as BlytzcollectFunnelRouteImport } from './routes/blytzcollect/funnel'
import { Route as ExampleFeedbackRouteImport } from './routes/example.feedback'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlytzcollectAnalyticsRoute = BlytzcollectAnalyticsRouteImport.update({
  id: '/blytzcollect/analytics',
  path: '/blytzcollect/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const BlytzcollectFunnelRoute = BlytzcollectFunnelRouteImport.update({
  id: '/blytzcollect/funnel',
  path: '/blytzcollect/funnel',
  getParentRoute: () => rootRouteImport,
} as any)
const ExampleFeedbackRoute = ExampleFeedbackRouteImport.update({
  id: '/example/feedback',
  path: '/example/feedback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/example/feedback': typeof ExampleFeedbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/example/feedback': typeof ExampleFeedbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/example/feedback': typeof ExampleFeedbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blytzcollect/analytics'
    | '/blytzcollect/funnel'
    | '/example/feedback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blytzcollect/analytics'
    | '/blytzcollect/funnel'
    | '/example/feedback'
  id:
    | '__root__'
    | '/'
    | '/blytzcollect/analytics'
    | '/blytzcollect/funnel'
    | '/example/feedback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlytzcollectAnalyticsRoute: typeof BlytzcollectAnalyticsRoute
  BlytzcollectFunnelRoute: typeof BlytzcollectFunnelRoute
  ExampleFeedbackRoute: typeof ExampleFeedbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blytzcollect/analytics': {
      id: '/blytzcollect/analytics'
      path: '/blytzcollect/analytics'
      fullPath: '/blytzcollect/analytics'
      preLoaderRoute: typeof BlytzcollectAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blytzcollect/funnel': {
      id: '/blytzcollect/funnel'
      path: '/blytzcollect/funnel'
      fullPath: '/blytzcollect/funnel'
      preLoaderRoute: typeof BlytzcollectFunnelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/example/feedback': {
      id: '/example/feedback'
      path: '/example/feedback'
      fullPath: '/example/feedback'
      preLoaderRoute: typeof ExampleFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlytzcollectAnalyticsRoute: BlytzcollectAnalyticsRoute,
  BlytzcollectFunnelRoute: BlytzcollectFunnelRoute,
  ExampleFeedbackRoute: ExampleFeedbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
